module.exports = __webpack_public_path__ + "static/media/Spinner.ac740c69.svg";